module.exports = {
  root: true,
  env: {
    browser: false,
    node: true
  },
  parser: '@babel/eslint-parser',
  parserOptions: {
    parser: '@babel/eslint-parser',
    ecmaVersion: 2020,
    sourceType: 'module',
    ecmaFeatures: {
      unicodeCodePointEscapes: true,
      globalReturn: true,
    }
  },
  extends: [
    'plugin:flowtype/recommended'
  ],
  // add your custom rules here
  rules: {
    "flowtype/no-types-missing-file-annotation": 0
  },
  settings: {
    flowtype: {
      onlyFilesWithFlowAnnotation: false
    }
  }
}
